import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function HelpTip({ text, testid }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" data-testid={testid} aria-label="Ayuda" className="inline-flex items-center justify-center text-white/40 hover:text-[#FF4438] transition-colors">
          <HelpCircle size={13} />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-[260px] text-xs leading-relaxed bg-[#161616] border-white/15 text-neutral-200">{text}</TooltipContent>
    </Tooltip>
  );
}

export function FieldLabel({ children, tipText, tipTestid, required = false }) {
  return (
    <div className="text-[13px] font-bold text-white/85 flex items-center gap-1.5 mb-2">
      <span>{children}{required && <span className="text-[#FF4438]"> *</span>}</span>
      {tipText && <HelpTip text={tipText} testid={tipTestid} />}
    </div>
  );
}

export function FieldError({ msg, testid }) {
  if (!msg) return null;
  return (
    <div className="mt-2 text-[13px] font-semibold text-[#ff6b61] flex items-center gap-1.5" data-testid={testid}>
      <span className="w-2.5 h-2.5 rounded-full bg-[#FF4438] flex-none" /> {msg}
    </div>
  );
}

export function Section({ n, title, right, invalid, children, testid }) {
  return (
    <section data-testid={testid} className={`rounded-[22px] p-4 sm:p-5 border ${invalid ? "border-[#FF4438]/45 bg-[#FF4438]/[.03]" : "border-white/12 bg-[#101010]"}`}>
      <div className="flex items-center justify-between mb-4">
        <span className={`sx-mono text-[10px] tracking-[.14em] ${invalid ? "text-[#ff6b61]" : "text-[#FF4438]"}`}>{n} · {title}</span>
        {right}
      </div>
      {children}
    </section>
  );
}

export function StepBar({ step, labels }) {
  return (
    <div className="mt-5">
      <div className="grid grid-cols-3 gap-1.5">
        {[1, 2, 3].map((n) => (
          <span key={n} data-testid={`auctions-step-${n}`} className="h-1 rounded-full"
                style={{ background: step > n ? "#34D399" : step === n ? "#FF4438" : "rgba(255,255,255,.12)" }} />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-1.5 mt-2">
        {labels.map((l, i) => (
          <span key={i} className="sx-mono text-[10px] tracking-[.12em] uppercase truncate"
                style={{ color: step > i + 1 ? "#34D399" : step === i + 1 ? "#fff" : "rgba(255,255,255,.35)" }}>{step > i + 1 ? `✓ ${l}` : l}</span>
        ))}
      </div>
    </div>
  );
}

export const inputCls = (bad) => `sx-input w-full h-[52px] px-4 text-[15px] ${bad ? "sx-invalid" : ""}`;
export const triggerCls = "sx-input h-[52px] px-4 text-[15px] rounded-[14px] bg-[#161616] border-white/14";
